import './avatar.css';import '../../tokens/contracts/border_radius/vars.css';import '../../styles/components/resets.css';/* empty css                                                   */
/* empty css                                */
/* empty css                             */
import { createRuntimeFn } from "@vanilla-extract/recipes/createRuntimeFn";
//#region src/components/avatar/avatar.css.ts
var avatarRootRecipe = createRuntimeFn({
	defaultClassName: "_1gcakkv1 _1gcakkv0 _14zs3h0 _14zs3h1",
	variantClassNames: {
		size: {
			"20": "_1gcakkv2",
			"32": "_1gcakkv3",
			"40": "_1gcakkv4"
		},
		kind: {
			initial: "_1gcakkv5",
			icon: "_1gcakkv6",
			image: "_1gcakkv7"
		}
	},
	defaultVariants: {
		size: 32,
		kind: "initial"
	},
	compoundVariants: []
});
var avatarColorRecipe = createRuntimeFn({
	defaultClassName: "_1gcakkv8",
	variantClassNames: { color: {
		blue: "_1gcakkv9",
		lime: "_1gcakkva",
		orange: "_1gcakkvb",
		teal: "_1gcakkvc",
		violet: "_1gcakkvd"
	} },
	defaultVariants: {},
	compoundVariants: []
});
var avatarImage = "_1gcakkve";
var avatarFallback = "_1gcakkvf";
var avatarFallbackTextRecipe = createRuntimeFn({
	defaultClassName: "_1gcakkvg",
	variantClassNames: { size: {
		"20": "_1gcakkvh",
		"32": "_1gcakkvi",
		"40": "_1gcakkvj"
	} },
	defaultVariants: { size: 32 },
	compoundVariants: []
});
var avatarIconRecipe = createRuntimeFn({
	defaultClassName: "_1gcakkvk",
	variantClassNames: { size: {
		"20": "_1gcakkvl",
		"32": "_1gcakkvm",
		"40": "_1gcakkvn"
	} },
	defaultVariants: { size: 32 },
	compoundVariants: []
});
//#endregion
export { avatarColorRecipe, avatarFallback, avatarFallbackTextRecipe, avatarIconRecipe, avatarImage, avatarRootRecipe };
